<div class="container notification-scroll-container">
    <div class="row p-3">
        <div class="col d-flex justify-content-end">
            <button nbButton status="basic" (click)="viewAllNotifications()">View All Notifications</button>
        </div>
    </div>
    <div class="pb-0">
        <ng-template [ngIf]="unreadNotifications.length > 0" [ngIfElse]="noUnreadNotifications">
            <div *ngFor="let notification of unreadNotifications">
                <div *ngIf="notification.read === false">
                    <div *ngIf="notification.type === notifTypes.HEARTBEAT">
                        <app-heartbeat-notification
                            [notification]="notification"
                            (markedRead)="setRead(notification, !notification.read)"
                            (deleteNotification)="deleteNotif(notification)"
                        ></app-heartbeat-notification>
                    </div>
                    <div *ngIf="notification.type === notifTypes.USAGE_ALERT">
                        <app-usage-alert-notification
                            [notification]="notification"
                            [entitlement]="entitlement"
                            (markedRead)="setRead(notification, !notification.read)"
                            (deleteNotification)="deleteNotif(notification)"
                        ></app-usage-alert-notification>
                    </div>
                    <div *ngIf="notification.type === notifTypes.BATTERY">
                        <app-battery-notification
                            [notification]="notification"
                            (markedRead)="setRead(notification, !notification.read)"
                            (deleteNotification)="deleteNotif(notification)"
                        ></app-battery-notification>
                    </div>
                    <div *ngIf="notification.type === notifTypes.BUDGET">
                        <app-budget-notification
                            [entitlement]="entitlement"
                            [notification]="notification"
                            (markedRead)="setRead(notification, !notification.read)"
                            (deleteNotification)="deleteNotif(notification)"
                        ></app-budget-notification>
                    </div>
                    <div *ngIf="notification.type === notifTypes.DEVICE_MOVED">
                        <app-device-moved
                            [notification]="notification"
                            (markedRead)="setRead(notification, !notification.read)"
                            (deleteNotification)="deleteNotif(notification)"
                        ></app-device-moved>
                    </div>
                    <div *ngIf="notification.type === notifTypes.GENERAL">
                        <app-general-notification
                            [notification]="notification"
                            (markedRead)="setRead(notification, !notification.read)"
                            (deleteNotification)="deleteNotif(notification)"
                        ></app-general-notification>
                    </div>
                </div>
            </div>
        </ng-template>
        <ng-template #noUnreadNotifications>
            <nb-card>
                <nb-card-body>
                    <div class="no-unread-container d-flex justify-content-center align-items-center">
                        <span class="text-muted">New Alerts Will Appear Here!</span>
                    </div>
                </nb-card-body>
            </nb-card>
        </ng-template>
    </div>
</div>
